import React, { useState } from 'react';

const SIZES = { sm: 24, md: 36, lg: 64 };

const BOT_FILES = {
  warren_buffett:  'warren_buffett',
  peter_lynch:     'peter_lynch',
  ray_dalio:       'ray_dalio',
  cathie_wood:     'cathie_wood',
  jesse_livermore: 'jesse_livermore',
};

const BOT_INITIALS = {
  warren_buffett:  'WB',
  peter_lynch:     'PL',
  ray_dalio:       'RD',
  cathie_wood:     'CW',
  jesse_livermore: 'JL',
};

const BOT_COLORS = {
  warren_buffett:  'bg-blue-600',
  peter_lynch:     'bg-green-600',
  ray_dalio:       'bg-purple-600',
  cathie_wood:     'bg-pink-600',
  jesse_livermore: 'bg-yellow-600',
};

// 한글 봇명 → key 매핑
const KR_TO_KEY = {
  '워런 버핏': 'warren_buffett',
  '피터 린치': 'peter_lynch',
  '레이 달리오': 'ray_dalio',
  '캐시 우드': 'cathie_wood',
  '제시 리버모어': 'jesse_livermore',
};

export function botNameToKey(name) {
  if (BOT_FILES[name]) return name;
  return KR_TO_KEY[name] || name;
}

export default function BotAvatar({ botName, size = 'md', className = '' }) {
  const [imgError, setImgError] = useState(false);
  const key = botNameToKey(botName);
  const file = BOT_FILES[key];
  const initials = BOT_INITIALS[key] || botName?.slice(0, 2)?.toUpperCase() || '??';
  const color = BOT_COLORS[key] || 'bg-gray-600';
  const px = SIZES[size] || SIZES.md;
  const fontSize = size === 'lg' ? 'text-xl' : size === 'sm' ? 'text-[10px]' : 'text-xs';

  if (file && !imgError) {
    return (
      <img
        src={`/avatars/${file}.jpg`}
        alt={botName}
        onError={() => setImgError(true)}
        className={`rounded-full object-cover flex-shrink-0 ${className}`}
        style={{ width: px, height: px }}
      />
    );
  }

  return (
    <div
      className={`rounded-full ${color} flex items-center justify-center font-bold flex-shrink-0 ${fontSize} ${className}`}
      style={{ width: px, height: px }}
    >
      {initials}
    </div>
  );
}
